import { AxiosResponse } from 'axios'
import { bffProxyUrl } from '@/utils/env'
import Vue from 'vue'
import {
  DriverTrackingIndicatorResponse,
  TrackingPayload,
  TrackingResponse,
  VehicleTrackingIndicatorResponse,
} from '@/models/dto/Tracking'

export default {
  /**
   * Gets the tracking data for a given journeyId and vehicleId pair for a provided reservation.
   *
   * @param payload - The payload containing data to be used for tracking.
   * @returns tracking data for the reservation by the journeyId and vehicleId pair.
   */
  byIdPairV2(
    payload: TrackingPayload
  ): Promise<AxiosResponse<TrackingResponse>> {
    const host = bffProxyUrl
    const url = `${host}/v2/tracking/data`
    return Vue.prototype.$http.post(url, payload)
  },

  /**
   * Gets the vehicle tracking indicators for a given set of vehicle IDs.
   *
   * @param vehicleIds - The vehicle IDs to retrieve tracking indicators for.
   * @returns tracking indicator data for each vehicle ID.
   */
  vehicleIndicators(
    vehicleIds: number[]
  ): Promise<AxiosResponse<VehicleTrackingIndicatorResponse>> {
    const host = bffProxyUrl
    const url = `${host}/tracking-indicator/vehicles`

    const params = new URLSearchParams(
      vehicleIds.map((id) => ['vehicleIds', id.toString()])
    );

    return Vue.prototype.$http.get(url, { params })
  },

  /**
   * Gets the driver tracking indicators for a given set of driver IDs.
   *
   * @param driverIds - The driver IDs to retrieve tracking indicators for.
   * @returns tracking indicator data for each driver ID.
   */
  driverIndicators(
    driverIds: number[]
  ): Promise<AxiosResponse<DriverTrackingIndicatorResponse>> {
    const host = bffProxyUrl
    const url = `${host}/tracking-indicator/drivers`

    const params = new URLSearchParams(
      driverIds.map((id) => ['driverIds', id.toString()])
    );

    return Vue.prototype.$http.get(url, { params })
  },
}
